import './Contacts.css';
import Footer from '../../components/Footer/Footer.jsx';
import YandexMap from '../../components/YandexMap/YandexMap.jsx';

function Contacts() {
  return (
    <>
    <div className='wrapper'>
      <div className='contacts-wrapper'>
        <div className='contacts-container'>
          <div className='map-container'>
            <YandexMap/>
          </div>
          <div className='text-container'>
            <p><b>адрес:</b> 606100 Нижегородская область г. Павлово,<br/> ул. Маяковского, д.4</p>
            <p><b>Web-адрес ОУ:</b> school6pav.ru</p>
            <p><b>E-mail:</b> s6_pvl@mail.52gov.ru</p>
            <p><b>Телефоны:</b><br/> 8(83171)2-10-44<br/>8(83171)2-10-45</p>
          </div>
        </div>
      </div>
      <Footer/>
    </div>
    </>
  );
}

export default Contacts;